export const CONSTANTS = {
    SOMETING_WENT_WORNG: "Something went wrong",
    SOMETING_WENT_WORNG_IN_SERVER: "Something went wrong in server",
    OPERATION_COMPLETED: "Operation completed",
    UNEXPECTED_ERROR: "Unexpected error",

    LESSON_ADDED: "Lesson added successfully",
    LESSON_UPDATED: "Lesson updated successfully",
    LESSON_DELETED: "Lesson deleted permanently"
    ,
    TOPIC_ADDED: "Topic added successfully",
    TOPIC_UPDATED: "Topic updated successfully",
    TOPIC_DELETED: "Topic deleted permanently"
};